import Onboard from "@web3-onboard/core";
import injected from "@web3-onboard/injected-wallets";
import walletConnect from "@web3-onboard/walletconnect";
import torus from "@web3-onboard/torus";
import Web3 from "web3";
import store from "../../store";
const api_key = "bd582b15de0741d8b61baeb738efb4dc";
import logo from "../../assets/rivet_svg_p2983k.svg";

export let getWeb3 = async () => {
    let _web3;
    if (!store.state.web3) {
        const wallets = await onboard.connectWallet();
        onboard.setChain({ chainId: process.env.VUE_APP_NETWORK_ID });
        _web3 = new Web3(wallets[0].provider);
        store.state.web3 = _web3;
        return Promise.resolve(_web3);
    } else {
        return Promise.resolve(store.state.web3);
    }
};

const onboard = Onboard({
    wallets: [injected(), walletConnect(), torus()],
    apiKey: "37182c69-7db8-4a1d-b64f-c95e4ef5b5f1",
    chains: [
        {
            id: "0x1",
            token: "ETH",
            namespace: "evm",
            label: "Ethereum Mainnet",
            rpcUrl: `https://${api_key}.eth.rpc.rivet.cloud/`,
        },
        {
            id: "0x3",
            token: "tROP",
            namespace: "evm",
            label: "Ethereum Ropsten Testnet",
            rpcUrl: `https://${api_key}.ropsten.rpc.rivet.cloud/`,
        },
        {
            id: "0x4",
            token: "rETH",
            namespace: "evm",
            label: "Ethereum Rinkeby Testnet",
            rpcUrl: `https://${api_key}.rinkeby.rpc.rivet.cloud/`,
        },
    ],
    appMetadata: {
        name: "Rivet.cloud",
        icon: logo,
        description: "Cloud-based Ethereum APIs",
        recommendedInjectedWallets: [
            {
                name: "MetaMask",
                url: "https://metamask.io/",
            },
            {
                name: "Coinbase",
                url: "https://wallet.coinbase.com/",
            },
        ],
    },
    accountCenter: {
        desktop: {
            enabled: false,
        },
    },
});
